import { render, staticRenderFns } from "./BarGrouped.vue?vue&type=template&id=15690252&scoped=true&"
import script from "./BarGrouped.vue?vue&type=script&lang=js&"
export * from "./BarGrouped.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15690252",
  null
  
)

export default component.exports